import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const EmptyCart = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-32 h-32 bg-muted rounded-full flex items-center justify-center mb-6">
        <Icon name="ShoppingCartIcon" size={64} className="text-muted-foreground" />
      </div>

      <h2 className="font-heading font-bold text-2xl text-foreground mb-2">
        Your Cart is Empty
      </h2>

      <p className="text-center text-muted-foreground mb-8 max-w-md">
        Looks like you haven't added any fresh fish to your cart yet. Start shopping to fill it up with quality seafood!
      </p>

      <Link
        href="/product-listing"
        className="flex items-center gap-2 px-8 py-3 bg-primary text-primary-foreground rounded-md font-heading font-semibold text-base transition-smooth hover:shadow-elevation-md hover-lift focus-ring"
      >
        <Icon name="ShoppingBagIcon" size={20} />
        <span>Start Shopping</span>
      </Link>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl">
        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-3">
            <Icon name="TruckIcon" size={24} className="text-primary" />
          </div>
          <h3 className="font-heading font-semibold text-sm text-foreground mb-1">
            Fast Delivery
          </h3>
          <p className="text-xs text-muted-foreground">
            Get fresh fish delivered to your doorstep
          </p>
        </div>

        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-3">
            <Icon name="ShieldCheckIcon" size={24} className="text-primary" />
          </div>
          <h3 className="font-heading font-semibold text-sm text-foreground mb-1">
            Quality Assured
          </h3>
          <p className="text-xs text-muted-foreground">
            100% fresh and hygienic seafood
          </p>
        </div>

        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-3">
            <Icon name="CurrencyRupeeIcon" size={24} className="text-primary" />
          </div>
          <h3 className="font-heading font-semibold text-sm text-foreground mb-1">
            Best Prices
          </h3>
          <p className="text-xs text-muted-foreground">
            Transparent pricing with no hidden charges
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyCart;